import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import "../../pages/doctor-console/DoctorConsole.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import { Row, Col } from "../../components/RowCol";
import { Table, Button } from "react-bootstrap";
import { Icon, TableHead } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useState } from "react";
import HiTypeHeader from "../../pages/doctor-console/Utils/HiTypeHeader";
import {
  formatDateIST,
  separateCamelCase,
} from "../../pages/doctor-console/Utils/UtilsFunctions";
import {
  AttachmentActionButtons,
  ModalActionButtons,
} from "../../pages/doctor-console/Utils/AttachmentActions";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";

/** Matches OP submission PDFs from PrintPrescForButtonDropDown (see DoctorConsole op attachments). */
const PRESCRIPTION_REPORT_MARKER = "Op_Prescription_Report";

function documentRefLooksLikePrescriptionReport(docRef) {
  if (!docRef || typeof docRef !== "object") return false;
  const id = String(docRef.id ?? "");
  const description = String(docRef.description ?? "");
  const att = docRef.content?.[0]?.attachment ?? docRef.content?.[0];
  const title = String(att?.title ?? "");
  return `${id} ${description} ${title}`.includes(PRESCRIPTION_REPORT_MARKER);
}

const OpConsultation = (props) => {
  const collapseByDefault = props.collapseByDefault;
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const opConsultationData = props.opConsultationData;
  console.log(" Op consulattion data from Op consult Page", opConsultationData);
  const viewAttachment = (attach) => {
    // console.log(attachment);
    console.log("Bahmni op type", attach.type);
    let attachment = attach.content[0];
    setCurrentAttachment(attachment);

    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };
  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };
  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
    setCurrentAttachment(null);
  };

  return (
    <>
      <DoctorconsoleGrid>
        {opConsultationData !== undefined && opConsultationData !== null ? (
          <>
            <HiTypeHeader
              date={opConsultationData.Date}
              name={"Op Consult Record"}
              encounter={opConsultationData.Encounter}
              organizationDetails={opConsultationData.Organization}
              practitionerDetails={opConsultationData.Practitioner}
            />
            {Object.keys(opConsultationData).map(
              (categoryKey) =>
                ![
                  "Encounter",
                  "Date",
                  "Organization",
                  "Practitioner",
                  "Patient",
                ].some(
                  (substring) =>
                    substring === categoryKey.match(/\(([^)]+)\)/)?.[1] ||
                    substring == categoryKey // Extract and check in the same line
                ) && (
                  <Accordion className="innermost-accordion" defaultExpanded={!collapseByDefault}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      className="innermost-accordion-summary"
                    >
                      <Typography
                        sx={{ color: "white" }}
                        className="accordion-section-title"
                      >
                        {categoryKey}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Row
                        style={{
                          marginTop: "30px",
                        }}
                      >
                        <Col
                          area="span 12"
                          style={{ border: "2px solid #ebf5f4" }}
                        >
                          {categoryKey.includes("DocumentReference") ? (
                            (() => {
                              const allDocs = opConsultationData[categoryKey] || [];
                              const prescriptionReportDocs = allDocs.filter(
                                documentRefLooksLikePrescriptionReport
                              );
                              const otherAttachmentDocs = allDocs.filter(
                                (d) => !documentRefLooksLikePrescriptionReport(d)
                              );
                              const renderDocButtons = (attachment, attIdx) => (
                                <span
                                  key={attIdx}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    marginRight: "12px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#007bff",
                                      color: "#fff",
                                      border: "none",
                                      padding: "5px 10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => viewAttachment(attachment)}
                                    title={attachment.id}
                                  >
                                    <i className="fas fa-file"></i>
                                  </button>
                                  <AttachmentActionButtons
                                    base64Data={
                                      attachment?.content?.[0]?.data
                                    }
                                    contentType={
                                      attachment?.content?.[0]?.content_type
                                    }
                                    filename={
                                      attachment?.id || "attachment"
                                    }
                                  />
                                </span>
                              );
                              return (
                                <div style={{ marginTop: "20px", marginBottom: "50px" }}>
                                  {prescriptionReportDocs.length > 0 && (
                                    <div
                                      style={{
                                        marginBottom: "24px",
                                        padding: "16px 18px",
                                        borderRadius: "8px",
                                        border: "2px solid #1565c0",
                                        background:
                                          "linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%)",
                                        boxShadow:
                                          "0 2px 8px rgba(21, 101, 192, 0.12)",
                                      }}
                                    >
                                      <Typography
                                        component="div"
                                        sx={{
                                          fontWeight: 700,
                                          fontSize: "17px",
                                          color: "#0d47a1",
                                          marginBottom: "10px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <span
                                          style={{
                                            display: "inline-block",
                                            padding: "2px 10px",
                                            borderRadius: "999px",
                                            fontSize: "12px",
                                            fontWeight: 700,
                                            letterSpacing: "0.04em",
                                            textTransform: "uppercase",
                                            backgroundColor: "#1565c0",
                                            color: "#fff",
                                          }}
                                        >
                                          Report
                                        </span>
                                        Prescription report
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "rgba(13, 71, 161, 0.85)",
                                          marginBottom: "12px",
                                          fontSize: "13px",
                                        }}
                                      >
                                        Formatted prescription PDF from the visit
                                        (print layout).
                                      </Typography>
                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "15px",
                                          color: "#1565c0",
                                        }}
                                      >
                                        Open :{" "}
                                        {prescriptionReportDocs.map(
                                          (attachment, attIdx) =>
                                            renderDocButtons(attachment, `report-${attIdx}`)
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {prescriptionReportDocs.length > 0
                                      ? "Other attachments"
                                      : "Attachments"}{" "}
                                    :{" "}
                                    {otherAttachmentDocs.length > 0
                                      ? otherAttachmentDocs.map(
                                          (attachment, attIdx) =>
                                            renderDocButtons(
                                              attachment,
                                              `other-${attIdx}`
                                            )
                                        )
                                      : prescriptionReportDocs.length > 0
                                        ? "None"
                                        : "No attachments found!"}
                                  </div>
                                </div>
                              );
                            })()
                          ) : (
                            <Table responsive size="lg">
                              <TableHead
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  gridTemplateColumns:
                                    "250px 250px 250px 120px 120px",
                                  justifyContent: "center",
                                }}
                              >
                                {/* Define table headers based on category */}
                                {categoryKey.includes("Condition") ? (
                                  <>
                                    <td>Name</td>
                                    <td>Clinical Status</td>
                                    <td>Recorded Date</td>
                                    <td>Clinical Notes</td>
                                  </>
                                ) : categoryKey.includes("Appointment") ? (
                                  <>
                                    <td>Start Date</td>
                                    <td>End Date</td>
                                    <td>Status</td>
                                    <td>Description</td>
                                  </>
                                ) : categoryKey.includes(
                                    "AllergyIntolerance"
                                  ) ? (
                                  <>
                                    <td>Name</td>
                                    <td>Clinical Status</td>
                                    <td>Verification Status</td>
                                    <td>Description</td>
                                    <td>Authored On</td>
                                  </>
                                ) : categoryKey.includes(
                                    "MedicationRequest"
                                  ) ? (
                                  <>
                                    <td>Medication</td>
                                    <td>Dosage and Route</td>
                                    <td>Reasons</td>
                                    <td>Authored Date</td>
                                    <td>Notes</td>
                                    {/* <td>Authored On</td> */}
                                    {/* Add other headers specific to Medications */}
                                  </>
                                ) : categoryKey.includes(
                                    "MedicationStatement"
                                  ) ? (
                                  <>
                                    <td>Medication</td>
                                    <td>Date Asserted</td>
                                    <td>Notes</td>
                                  </>
                                ) : categoryKey.includes("Observation") ? (
                                  <>
                                    <td>Title</td>

                                    <td>Value</td>
                                    <td>Unit</td>
                                    <td>Notes</td>
                                    <td>Status</td>
                                  </>
                                ) : categoryKey.includes(
                                    "FamilyMemberHistory"
                                  ) ? (
                                  <>
                                    <td>Relation</td>

                                    <td>Condition</td>
                                    <td>On Set Age</td>
                                    <td>Deceased</td>
                                    <td>Status</td>
                                    <td>Date</td>
                                    <td>Notes</td>
                                  </>
                                ) : categoryKey.includes("Procedure") ? (
                                  <>
                                    <td>Name</td>
                                    {/* <td>Authored On</td> */}
                                    <td>Status</td>
                                    <td>Performed On</td>
                                    <td>Notes</td>
                                    {/* Add other headers specific to Tests */}
                                  </>
                                ) : categoryKey.includes("ServiceRequest") ? (
                                  <>
                                    <td>Name</td>
                                    {/* <td>Authored On</td> */}
                                    <td>Status</td>
                                    <td>Authored Date</td>
                                    <td>Notes</td>
                                    {/* Add other headers specific to Tests */}
                                  </>
                                ) : categoryKey !== "Encounter" ? (
                                  <>
                                    <td>Name</td>
                                    {/* <td>Authored On</td> */}
                                    <td>Status</td>
                                    {/* Add other headers specific to Tests */}
                                  </>
                                ) : null}
                              </TableHead>
                              <tbody>
                                {/* Render rows for each item within the category */}
                                {opConsultationData?.[categoryKey].map(
                                  (item) => (
                                    <tr key={item.id}>
                                      {" "}
                                      {console.log("Item OP", item)}
                                      {/* Render cells based on category */}
                                      {categoryKey.includes("Condition") ? (
                                        <>
                                          {console.log(
                                            "Item Found",
                                            categoryKey
                                          )}
                                          <td>
                                            {item?.code?.[0]?.display
                                              ? item.code[0].display
                                              : item.code[0]}
                                          </td>

                                          <td>
                                            {(
                                              item?.clinical_status?.[0]
                                                ?.display || ""
                                            ).trim() || "-"}
                                          </td>

                                          <td>
                                            {item.recorded_date &&
                                            item.recorded_date !== ""
                                              ? formatDateIST(
                                                  item.recorded_date
                                                )
                                              : "-"}
                                          </td>
                                          <td>
                                            {item?.note && item?.note.length > 0
                                              ? item?.note?.[0].text
                                              : "-"}
                                          </td>
                                        </>
                                      ) : categoryKey.includes(
                                          "Appointment"
                                        ) ? (
                                        <>
                                          <td>
                                            {item?.start
                                              ? formatDate(item.start)
                                              : "NA"}
                                          </td>

                                          <td>
                                            {item?.end
                                              ? formatDate(item.end)
                                              : "NA"}
                                          </td>

                                          <td>{item?.status ?? "NA"}</td>
                                          <td>
                                            {(item?.description || "").trim() ||
                                              "NA"}
                                          </td>
                                        </>
                                      ) : categoryKey.includes(
                                          "AllergyIntolerance"
                                        ) ? (
                                        <>
                                          {console.log(
                                            "Item Found",
                                            categoryKey
                                          )}
                                          <td>
                                            {item?.code?.[0]?.display
                                              ? item.code[0].display
                                              : item.code[0]}
                                          </td>

                                          <td>
                                            {item?.clinical_status?.[0]
                                              ?.display ?? "-"}
                                          </td>
                                          <td>
                                            {item?.verification_status?.[0]
                                              ?.display ?? "-"}
                                          </td>
                                          <td>
                                            {item?.note?.[0]?.text ?? "-"}
                                          </td>
                                          <td>
                                            {item.recorded_date
                                              ? formatDateIST(
                                                  item.recorded_date
                                                )
                                              : "-"}
                                          </td>
                                        </>
                                      ) : categoryKey.includes(
                                          "MedicationRequest"
                                        ) ? (
                                        <>
                                          {console.log(
                                            "Medication Item Found",
                                            categoryKey,
                                            item
                                          )}
                                          <td>
                                            {item?.medication
                                              ? typeof item.medication ===
                                                "object"
                                                ? item.medication.display
                                                : item.medication
                                              : typeof item?.code?.[0] ===
                                                  "object" &&
                                                item.code[0]?.display
                                              ? item.code[0].display
                                              : item.code[0]}
                                          </td>

                                          <td>
                                            {item?.dosage?.[0]}
                                            {item?.dosage?.[1]?.display
                                              ? ` ${item.dosage[1].display}`
                                              : ""}
                                          </td>
                                          <td>
                                            {item?.reason_code?.length > 0
                                              ? item.reason_code.join(", ")
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.authored_on
                                              ? formatDateIST(item.authored_on)
                                              : "-"}
                                          </td>
                                          <td>
                                            {item?.note && item?.note.length > 0
                                              ? item?.note?.[0].text
                                              : "-"}
                                          </td>
                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          {/* Render other cells specific to Medications */}
                                        </>
                                      ) : categoryKey.includes(
                                          "MedicationStatement"
                                        ) ? (
                                        <>
                                          <td>
                                            {typeof item?.code?.[0] ===
                                              "object" && item.code[0]?.display
                                              ? item.code[0].display
                                              : item.code[0]}
                                          </td>

                                          <td>{item?.date_asserted}</td>
                                          <td>
                                            {item?.note && item?.note.length > 0
                                              ? item?.note?.[0].text
                                              : "-"}
                                          </td>

                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          {/* Render other cells specific to Medications */}
                                        </>
                                      ) : categoryKey.includes(
                                          "Observation"
                                        ) ? (
                                        <>
                                          {console.log(
                                            "Item Found",
                                            categoryKey
                                          )}
                                          <td>
                                            {item?.code && item.code.length > 0
                                              ? item.code[item.code.length - 1]
                                                  .text ||
                                                item.code[item.code.length - 1]
                                                  .display ||
                                                "-"
                                              : "-"}
                                          </td>

                                          <td>
                                            {item &&
                                            item.value_quantity &&
                                            Object.keys(item.value_quantity)
                                              .length > 0
                                              ? item.value_quantity.value !==
                                                undefined
                                                ? item.value_quantity.value
                                                : item.value_quantity.string ||
                                                  item.value_quantity
                                                    .value_text ||
                                                  item.value_quantity
                                                    .value_datetime
                                              : "-"}
                                          </td>

                                          <td>
                                            {item?.value_quantity?.unit?.trim() ||
                                              "-"}
                                          </td>

                                          <td>
                                            {item?.note && item?.note.length > 0
                                              ? item?.note?.[0].text
                                              : "-"}
                                          </td>
                                          <td>{item && item.status}</td>

                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          {/* Render other cells specific to Medications */}
                                        </>
                                      ) : categoryKey.includes(
                                          "FamilyMemberHistory"
                                        ) ? (
                                        <>
                                          <td>
                                            {item?.relationship?.[0] ?? "-"}
                                          </td>
                                          <td>{item?.code?.[0] ?? "-"}</td>

                                          <td>
                                            {item?.onset_age?.value ?? "-"}
                                          </td>

                                          <td>
                                            {item.contributed_to_death
                                              ? "Yes"
                                              : "No"}
                                          </td>
                                          <td>{item?.status ?? "-"}</td>
                                          <td>{item?.date ?? "-"}</td>
                                          <td>
                                            {item?.note && item?.note.length > 0
                                              ? item?.note?.[0].text
                                              : "-"}
                                          </td>

                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          {/* Render other cells specific to Medications */}
                                        </>
                                      ) : categoryKey.includes("Procedure") ? (
                                        <>
                                          <td>
                                            {item?.code?.[0]?.display
                                              ? item.code[0].display
                                              : item.code[0]}
                                          </td>
                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          <td>{item?.status}</td>
                                          <td>
                                            {item?.performed_datetime
                                              ? formatDateIST(
                                                  item.performed_datetime
                                                )
                                              : "-"}
                                          </td>
                                          <td>
                                            {item?.note && item?.note.length > 0
                                              ? item?.note?.[0].text
                                              : "-"}
                                          </td>

                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          {/* Render other cells specific to Medications */}
                                        </>
                                      ) : categoryKey.includes(
                                          "ServiceRequest"
                                        ) ? (
                                        <>
                                          <td>
                                            {item?.code?.[0]?.display
                                              ? item.code[0].display
                                              : item.code[0]}
                                          </td>
                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          <td>{item?.status}</td>
                                          <td>
                                            {item?.authored_on
                                              ? formatDateIST(item.authored_on)
                                              : "-"}
                                          </td>
                                          <td>
                                            {item?.note && item?.note.length > 0
                                              ? item?.note?.[0].text
                                              : "-"}
                                          </td>
                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          {/* Render other cells specific to Medications */}
                                        </>
                                      ) : categoryKey !== "Encounter" ? (
                                        <>
                                          {console.log(
                                            "Item Found",
                                            categoryKey
                                          )}
                                          <td>
                                            {item?.code?.[0]?.display
                                              ? item.code[0].display
                                              : item.code[0]}
                                          </td>
                                          {/* <td>{formatDate(item?.date)}</td> */}
                                          <td>{item?.status}</td>
                                          {/* Render other cells specific to Tests */}
                                        </>
                                      ) : null}
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          )}
                        </Col>
                      </Row>
                    </AccordionDetails>
                  </Accordion>
                )
            )}
          </>
        ) : (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#3AC8BA",
              fontWeight: "bold",
              fontSize: "25px",
            }}
          >
            No Op Consultation Data found!
          </div>
        )}
      </DoctorconsoleGrid>

      <Helmet>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
          crossorigin="anonymous"
        />
      </Helmet>
      <Modal open={showModal} onClose={closeModal}>
        <Box className="modal-box">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "4px",
              padding: "8px 12px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            {currentAttachment && (
              <ModalActionButtons
                base64Data={currentAttachment.data}
                contentType={currentAttachment.content_type}
                filename="attachment"
              />
            )}
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography variant="h6">PDF Viewer</Typography> */}

          <div style={{ flex: 1 }}>{modalContent}</div>
        </Box>
      </Modal>
    </>
  );
};
const datapoints = [20, 50, 30, 20, 35, 40, 30, 20, 40, 30];
const state = {
  labels: [
    "Jan-2021",
    "Feb-2021",
    "Mar-2021",
    "Apr-2021",
    "May-2021",
    "Jun-2021",
    "Jul-2021",
    "Aug-2021",
    "Sep-2021",
  ],
  datasets: [
    {
      //label: 'Cubic interpolation (monotone)',
      label: "WBC Count",
      data: datapoints,
      //borderColor: 'rgba(255, 0, 0)',
      borderColor: "rgba(51, 0, 0, 0.8)",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderWidth: 1.5,
      fill: false,
      //cubicInterpolationMode: 'monotone',
      tension: 0,
    },
    /*, {
        label: 'Cubic interpolation',
        data: datapoints,
        borderColor: 'rgba(0, 0, 255)',
        borderWidth: 1.5,
        fill: false,
        tension: 0.4
    }, {
        label: 'Linear interpolation (default)',
        data: datapoints,
        borderColor: 'rgba(0, 128 ,0)',
        borderWidth: 1.5,
        fill: false
    }*/
  ],
};

const progressColors = {
  green: "#01A601",
  pink: "#E87971",
  blue: "#05C4E2",
  orange: "#F66220",
};

const Progress = styled.div`
  height: 0.6rem;
  background-color: #ccd0d2;
  display: grid;
  grid-template-columns: ${(props) => props.width} calc(
      100% - ${(props) => props.width}
    );
  border-radius: 50px;
  width: 100%;
  .progress-item {
    height: 0.6rem;
    background-color: ${({ color }) => progressColors[color]};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 50px;
    span {
      font-size: 0.8rem;
      color: #94999c;
      margin-top: -3rem;
    }
  }
  .bg {
    width: 100%;
  }
`;
const ProgressBar = ({ color, width }) => {
  return (
    <Progress color={color} width={width}>
      <div className="progress-item">
        <span>{width}</span>
      </div>
      <div className="bg"></div>
    </Progress>
  );
};
export default OpConsultation;
